import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import pricingCss from "../pricing.css?url";
import { PricingPage } from "../pricing/PricingPage";

export const Route = createFileRoute("/pricing")({
  head: () => ({
    meta: [
      { title: "Pricing - Salesko" },
      {
        name: "description",
        content: "Salesko Agent research plans: subscription tiers with monthly credit allowances plus one-time credit packs."
      },
      { property: "og:title", content: "Salesko - Pricing" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://salesko.ai/pricing" }
    ],
    links: [
      { rel: "canonical", href: "https://salesko.ai/pricing" },
      { rel: "stylesheet", href: pricingCss }
    ]
  }),
  component: PricingRoute
});

// PricingPage calls useQuery/useMutation for the billing catalog and checkout,
// so the route must own a QueryClient the way /app and /connectors do. The root
// only provides I18nProvider; without this the page throws "No QueryClient set"
// and renders the error boundary instead of the plans.
function PricingRoute() {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      <PricingPage />
    </QueryClientProvider>
  );
}
